var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolRectangle = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.65
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.606 15.5v7.576M23.394 19.288h-7.576"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.03 19.288H6a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2h13.892a2 2 0 0 1 2 2v4.506h0",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}))));
export { SvgToolRectangle as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-rectangle.svg";